import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
  loginApi,
  otpResendApi,
  otpVerifyApi,
  registrationApi,
} from "@/api/end-points/auth";

export const useLogin = (useQueryOptions) => {
  const { onSuccess = () => {}, onError = () => {} } = useQueryOptions || {};

  return useMutation(loginApi, {
    onSuccess: (res) => {
      onSuccess({
        status: res.status,
        data: res.data?.data,
        message: res.data.message,
      });
    },
    onError: (error) => {
      onError({
        status: error.response.status,
        errors: error.response.data?.errors,
        message: error.message,
      });
    },
  });
};

export const useVerifyOtp = (useQueryOptions) => {
  const queryClient = useQueryClient();
  const { onSuccess = () => {}, onError = () => {} } = useQueryOptions || {};

  return useMutation(otpVerifyApi, {
    onSuccess: (res) => {
      onSuccess({
        status: res.status,
        data: res.data?.data,
        message: res.data?.message,
      });
      queryClient.invalidateQueries({ queryKey: ["notifications"] });
    },
    onError: (error) => {
      onError({
        status: error.response.status,
        data: error.response.data,
        message: error.response.data?.errors?.[0]?.message,
      });
    },
  });
};

export const useResendOtp = (useQueryOptions) => {
  const { onSuccess = () => {}, onError = () => {} } = useQueryOptions || {};

  return useMutation(otpResendApi, {
    onSuccess: (res) => {
      onSuccess({
        status: res.status,
        data: res.data,
      });
    },
    onError: (error) => {
      onError({
        status: error.response.status,
        data: error.response.data,
        message: error.message,
      });
    },
  });
};

export const useRegister = (useQueryOptions) => {
  const queryClient = useQueryClient();
  const { onSuccess = () => {}, onError = () => {} } = useQueryOptions || {};

  return useMutation(registrationApi, {
    onSuccess: (res) => {
      onSuccess({
        status: res.status,
        data: res.data?.data,
      });
      queryClient.invalidateQueries({ queryKey: ["notifications"] });
    },
    onError: (error) => {
      onError({
        status: error.response.status,
        errors: error.response.data?.errors,
        message: error.message,
      });
    },
  });
};
